import React, {useState, useEffect} from 'react';

const CharTypeRestrictions = ({value, onChange}) => {

  const [model, setModel] = useState(value || {});
  const [enabled, setEnabled] = useState(Object.keys(model).length > 0);

  useEffect(() => onChange(enabled ? model : null), [model]);

  return <div className="mb-2">
    <div className="form-check mb-1">
      <input id="charTypeRestrictionsEnabled"
             type="checkbox"
             className="form-check-input"
             checked={enabled}
             onChange={e => setEnabled(e.target.checked)}/>
      <label className="form-check-label" htmlFor="charTypeRestrictionsEnabled">
        Restrict the type of character allowed
      </label>
    </div>
    {enabled &&
      <div className="row justify-content-end">
        <div className="col-11">
          <div className="form-check">
            <input id="charTypeRestrictionsIgnoreNumbers"
                   type="checkbox"
                   className="form-check-input"
                   checked={!!model.ignoreNumbers}
                   onChange={e => setModel({...model, ignoreNumbers: e.target.checked})}/>
            <label className="form-check-label" htmlFor="charTypeRestrictionsIgnoreNumbers">
              Automatically ignore numbers
            </label>
          </div>
        </div>
      </div>
    }
  </div>;
}

export default CharTypeRestrictions;
